var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      "x-large": "",
                      color: "light-blue lighten-2",
                      icon: "fa-plus",
                      tooltip: _vm.$t("global.crud.button.add")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.create()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { sm: "6", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("global.datatable.search"),
                                  "append-icon": "fas fa-search",
                                  "single-line": ""
                                },
                                model: {
                                  value: _vm.filter.allFields,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "allFields", $$v)
                                  },
                                  expression: "filter.allFields"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "6", cols: "12" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.deletedItemsValues,
                                  label: _vm.$t("global.status")
                                },
                                model: {
                                  value: _vm.filter.deletedItems,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "deletedItems", $$v)
                                  },
                                  expression: "filter.deletedItems"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.refreshItemsView()
                      }
                    }
                  }),
                  _c("ExportExcel", {
                    attrs: { url: "/productsTypes", filter: this.filter }
                  }),
                  _c("ImportExcel", {
                    attrs: { url: "/productsTypes" },
                    on: { done: _vm.search }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ items }) {
                    return [
                      _c(
                        "tbody",
                        _vm._l(items, function(item) {
                          return _c(
                            "tr",
                            {
                              key: item.code,
                              attrs: { title: item.description }
                            },
                            [
                              _c(
                                "td",
                                [
                                  _c("crud-button", {
                                    attrs: {
                                      "x-small": "",
                                      color: "orange",
                                      icon: "fa-pen",
                                      tooltip: _vm.$t(
                                        "global.crud.buttons.edit"
                                      )
                                    },
                                    on: {
                                      clicked: function($event) {
                                        return _vm.edit(item.code)
                                      }
                                    }
                                  }),
                                  item.deletionDate === undefined ||
                                  item.deletionDate === null
                                    ? _c("crud-button", {
                                        attrs: {
                                          "x-small": "",
                                          color: "red",
                                          icon: "fa-trash",
                                          tooltip: _vm.$t(
                                            "global.crud.buttons.delete"
                                          )
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.suspend(item.code)
                                          }
                                        }
                                      })
                                    : _c("crud-button", {
                                        attrs: {
                                          "x-small": "",
                                          color: "green",
                                          icon: "fa-redo",
                                          tooltip: _vm.$t(
                                            "global.crud.buttons.restore"
                                          )
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.restore(item.code)
                                          }
                                        }
                                      }),
                                  _c("crud-button", {
                                    attrs: {
                                      "x-small": "",
                                      color: "orange",
                                      icon: "fa-bars",
                                      tooltip: _vm.$t(
                                        "global.crud.buttons.parametrizeByDelegation"
                                      )
                                    },
                                    on: {
                                      clicked: function($event) {
                                        return _vm.productsTypesOperations(
                                          item.code
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(item.code))]),
                              _c("td", [_vm._v(_vm._s(item.defaultTime))])
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            "no-click-animation": ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("validation-observer", {
            ref: "obs",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ invalid, validated, passes }) {
                  return [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              dark: "",
                              color: "primary",
                              dense: "",
                              flat: ""
                            }
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              { staticClass: "white--text" },
                              [_vm._v(" " + _vm._s(_vm.formTitle) + " ")]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("fas fa-times")])],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "details-list" },
                          [
                            _c(
                              "v-form",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("productsTypes.code"),
                                            rules: "required|max:30"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "productsTypes.code"
                                                        ),
                                                        disabled: _vm.editMode,
                                                        required: "",
                                                        "error-messages": errors
                                                      },
                                                      model: {
                                                        value: _vm.item.code,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "code",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "item.code"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t(
                                              "productsTypes.defaultTime"
                                            ),
                                            rules: "required|max:30"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "productsTypes.defaultTime"
                                                        ),
                                                        required: "",
                                                        "error-messages": errors,
                                                        counter: "30"
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.defaultTime,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "defaultTime",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.defaultTime"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "black", text: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.buttons.close")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.editMode
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "orange", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.update)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.update")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "green", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.save)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.create")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }